import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VDialog,
    {
      attrs: { "max-width": "1180", persistent: "", scrollable: "" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        VCard,
        { staticClass: "partition-review-dialog" },
        [
          _c(
            "div",
            { staticClass: "dialog-header" },
            [
              _c(
                "div",
                { staticClass: "dialog-title-wrap" },
                [
                  _c("div", { staticClass: "dialog-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("ownership_requests.review_dialog.title"))
                    ),
                  ]),
                  _c(
                    VChip,
                    {
                      staticClass: "dialog-status",
                      attrs: {
                        small: "",
                        outlined: "",
                        color: _vm.validationChipColor,
                      },
                    },
                    [
                      _c(VIcon, { attrs: { left: "", "x-small": "" } }, [
                        _vm._v(_vm._s(_vm.validationIcon)),
                      ]),
                      _vm._v(" " + _vm._s(_vm.validationLabel) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: { icon: "", disabled: _vm.isBusy },
                  on: { click: _vm.close },
                },
                [_c(VIcon, [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            VCardText,
            { staticClass: "dialog-body" },
            [
              _vm.scriptLoading || _vm.detailLoading
                ? _c(VProgressLinear, {
                    staticClass: "mb-3",
                    attrs: { indeterminate: "", color: "primary" },
                  })
                : _vm._e(),
              _c("div", { staticClass: "request-summary" }, [
                _c("div", { staticClass: "summary-item summary-item--wide" }, [
                  _c("div", { staticClass: "info-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("ownership_requests.create_attribute.use_case")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.requestTitle)),
                  ]),
                ]),
                _c("div", { staticClass: "summary-item" }, [
                  _c("div", { staticClass: "info-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("ownership_requests.create_attribute.table_name")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.tableNameLabel)),
                  ]),
                ]),
                _c("div", { staticClass: "summary-item" }, [
                  _c("div", { staticClass: "info-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("ownership_requests.create_attribute.periods")
                      )
                    ),
                  ]),
                  _vm.periodDisplayItems.length
                    ? _c(
                        "div",
                        { staticClass: "period-list" },
                        _vm._l(_vm.periodDisplayItems, function (period) {
                          return _c(
                            VChip,
                            {
                              key: period.raw,
                              staticClass: "period-chip",
                              attrs: {
                                "x-small": "",
                                outlined: "",
                                color: "primary",
                              },
                            },
                            [_vm._v(" " + _vm._s(period.label) + " ")]
                          )
                        }),
                        1
                      )
                    : _c("div", { staticClass: "info-value" }, [
                        _vm._v(_vm._s(_vm.periodsLabel)),
                      ]),
                ]),
              ]),
              _c("div", { staticClass: "review-layout" }, [
                _c(
                  "section",
                  { staticClass: "editor-panel" },
                  [
                    _c(
                      "div",
                      { staticClass: "panel-header" },
                      [
                        _c("div", { staticClass: "min-w-0" }, [
                          _c("div", { staticClass: "section-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ownership_requests.review_dialog.script_label"
                                )
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "section-meta" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.scriptFilename) +
                                " - " +
                                _vm._s(
                                  _vm.$t(
                                    "ownership_requests.review_dialog.lines_label",
                                    { count: _vm.scriptLineCount }
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _vm.scriptChanged
                          ? _c(
                              VChip,
                              {
                                staticClass: "state-chip",
                                attrs: {
                                  "x-small": "",
                                  color: "warning",
                                  "text-color": "white",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "ownership_requests.review_dialog.edited_badge"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.scriptError
                      ? _c(
                          VAlert,
                          {
                            staticClass: "ma-4",
                            attrs: { type: "warning", outlined: "", dense: "" },
                          },
                          [_vm._v(" " + _vm._s(_vm.scriptError) + " ")]
                        )
                      : _c(VTextarea, {
                          staticClass: "script-editor",
                          attrs: {
                            outlined: "",
                            "no-resize": "",
                            rows: "18",
                            "hide-details": "",
                            spellcheck: "false",
                            readonly: _vm.isBusy,
                          },
                          model: {
                            value: _vm.scriptText,
                            callback: function ($$v) {
                              _vm.scriptText = $$v
                            },
                            expression: "scriptText",
                          },
                        }),
                  ],
                  1
                ),
                _c("section", { staticClass: "validation-panel" }, [
                  _c("div", { staticClass: "panel-header" }, [
                    _c("div", { staticClass: "min-w-0" }, [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "create_attribute.partition_validation.panel_title"
                            )
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "section-meta" }, [
                        _vm._v(_vm._s(_vm.validationLabel)),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "validation-content" },
                    [
                      _vm.isValidationOk
                        ? _c(
                            VAlert,
                            {
                              staticClass: "mb-0",
                              attrs: {
                                type: "success",
                                outlined: "",
                                dense: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "ownership_requests.review_dialog.validation_ok"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm.validation
                        ? _c("partition-validation-errors", {
                            attrs: { validation: _vm.validation },
                          })
                        : _c(
                            "div",
                            { staticClass: "empty-state" },
                            [
                              _c(
                                VIcon,
                                { attrs: { color: "grey lighten-1" } },
                                [_vm._v("mdi-clipboard-text-search-outline")]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "ownership_requests.review_dialog.no_validation"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            VCardActions,
            { staticClass: "dialog-actions" },
            [
              _c(
                VBtn,
                {
                  attrs: {
                    outlined: "",
                    color: "primary",
                    disabled: _vm.isBusy || !_vm.scriptChanged,
                  },
                  on: { click: _vm.restoreOriginalScript },
                },
                [
                  _c(VIcon, { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-restore"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("ownership_requests.review_dialog.reset_script")
                      ) +
                      " "
                  ),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  attrs: {
                    outlined: "",
                    color: "secondary",
                    loading: _vm.verifying,
                    disabled: _vm.isBusy || !_vm.canVerify,
                  },
                  on: { click: _vm.onVerifyClick },
                },
                [
                  _c(VIcon, { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-robot-outline"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("ownership_requests.review_dialog.revalidate")
                      ) +
                      " "
                  ),
                ],
                1
              ),
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: { text: "", disabled: _vm.isBusy },
                  on: { click: _vm.close },
                },
                [_vm._v(" " + _vm._s(_vm.$t("btns.close")) + " ")]
              ),
              _c(
                VBtn,
                {
                  attrs: {
                    color: "primary",
                    loading: _vm.approving,
                    disabled: !_vm.canSubmit,
                  },
                  on: { click: _vm.onApproveClick },
                },
                [
                  _c(VIcon, { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-check"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("ownership_requests.review_dialog.approve")
                      ) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }